import { createFeatureSelector, createSelector } from '@ngrx/store';

import { NewslettersState }                      from '../';

import { getABTestStatus } from '../../views/ab-test/ab-test.utils';


export const selectNewsletters = createFeatureSelector<NewslettersState>('newsletters');

export const selectTemplateVariables = createSelector(
  selectNewsletters,
  (state: NewslettersState) => state.variables
);
export const selectCampaignsState = createSelector(
  selectNewsletters,
  (state: NewslettersState) => state.campaigns
);

export const selectTemplateSubject = createSelector(
  selectNewsletters,
  (state: NewslettersState) => state.subject
);

export const selectTemplatePipeline = createSelector(
  selectNewsletters,
  (state: NewslettersState) => state.pipeline
);

export const selectTemplateRecos = createSelector(
  selectNewsletters,
  (state: NewslettersState) => state.recos
);

export const selectAuthor = createSelector(
  selectNewsletters,
  (state: NewslettersState) => state.author
);

export const selectABTests = createSelector(
  selectNewsletters,
  (state: NewslettersState) => state.abTests
);

// Tests A/B scheduled ou running de la source courante (les finished ne sont plus modifiables), triés du plus
// proche au plus lointain — alimente le toggle "édition Test AB", dont le choix par défaut est le premier de la
// liste. Un test running a un startDate dans le passé, donc il remonte naturellement avant les scheduled (futurs)
// et reste privilégié par défaut.
export const selectEditableABTests = createSelector(
  selectABTests,
  (tests) => tests
    .filter((test) => getABTestStatus(test) !== 'finished')
    .sort((a, b) => a.startDate - b.startDate)
);

export const selectABTestEditingSelection = createSelector(
  selectNewsletters,
  (state: NewslettersState) => state.abTestEditingSelection
);
